var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88238 9.94276L12.9312 6.68754L7.88238 3.42165V9.94276ZM5.05344 13.3644C4.6459 13.3644 4.29574 13.2176 4.00294 12.924C3.71013 12.6305 3.56373 12.2794 3.56373 11.8708V1.50427C3.56373 1.09274 3.71013 0.739149 4.00294 0.443489C4.29574 0.14783 4.6459 0 5.05344 0H15.393C15.8035 0 16.1562 0.14783 16.4511 0.443489C16.7459 0.739149 16.8934 1.09274 16.8934 1.50427V11.8708C16.8934 12.2794 16.7459 12.6305 16.4511 12.924C16.1562 13.2176 15.8035 13.3644 15.393 13.3644H5.05344ZM5.05344 11.8708H15.393V1.50427H5.05344V11.8708ZM2.43541 16C2.02496 16 1.67229 15.8521 1.37739 15.5564C1.0825 15.2608 0.935059 14.9072 0.935059 14.4957V2.63552H2.43541V14.4957H14.2647V16H2.43541Z",
    fill: "#A5A4BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.f1e27d56d56caf1f5827f4d997803ab4.svg";
export { ForwardRef as ReactComponent };